export const TOKEN_EXPIRY_WARNING_DAYS = 30;
/** The warning window is capped at this fraction of the token's lifetime so a
 * short-lived token is not flagged the day it is created. Mirrors the backend
 * sweep in `tokens/list_expiring_unnotified.sql`. */
export const TOKEN_EXPIRY_WARNING_LIFETIME_FRACTION = 0.1;
export const TOKEN_EXPIRY_BANNER_DISMISS_KEY = "definity:token-expiry-banner";
